import { Column } from '@tanstack/react-table';
import { IconArrowDown, IconArrowUp } from '@tabler/icons-react';

enum SortType {
  ASC = 'asc',
  DESC = 'desc'
}

function SortToggler({ type }: { type?: SortType }) {
  return (
    <>
      {(!type || type === SortType.ASC) && (
        <IconArrowUp
          size={16}
          className={type === SortType.ASC ? 'text-foreground' : 'text-muted-foreground'}
        />
      )}
      {type === SortType.DESC && (
        <IconArrowDown size={16} className="text-foreground" />
      )}
    </>
  );
}

interface HeaderSortProps<TData> {
  column: Column<TData, unknown>;
  sort?: boolean;
}

export default function HeaderSort<TData>({ column, sort }: HeaderSortProps<TData>) {
  return (
    <div
      {...(sort && { onClick: column.getToggleSortingHandler() })}
      className={sort ? 'cursor-pointer' : ''}
    >
      {{
        asc: <SortToggler type={SortType.ASC} />,
        desc: <SortToggler type={SortType.DESC} />
      }[column.getIsSorted() as string] ?? <SortToggler />}
    </div>
  );
}
